import { useBreakpointValue } from "@gluestack-ui/themed";
import { zodResolver } from "@hookform/resolvers/zod";
import useToast from "@repo/core/components/core/Toast";
import { IdentityInputTypeEnum } from "@repo/core/components/forms/IdentityTypeInput/types";
import { useIdentityTypeInput } from "@repo/core/hooks/useIdentityTypeInput";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";
import { apiInstance } from "@repo/core/services/instances/api";
import { TerminalResource } from "@repo/core/services/resources/terminal";
import { Z } from "@repo/core/utils/zod.utils";
import { AxiosError } from "axios";
import { useForm } from "react-hook-form";

const cpfFormSchema = Z.object({
  cpf: Z.string().cpf()
});

const cardFormSchema = Z.object({
  card: Z.string().min(16, {
    message: "O número do cartão deve ter 16 dígitos"
  })
});

const terminalResource = new TerminalResource(apiInstance);

export const LimitsVerifyIdentityController = () => {
  const { push, back } = useNavigation();
  const isMobile = useBreakpointValue({ base: true, md: false });

  const { error } = useToast();

  const {
    productInfo,
    selectedIdentityInputType,
    handleOnChangeIdentityType,
    handleOnSelectProduct
  } = useIdentityTypeInput({});

  const formSchema =
    selectedIdentityInputType === IdentityInputTypeEnum.CPF
      ? cpfFormSchema
      : cardFormSchema;

  const {
    control,
    handleSubmit,
    formState: { isSubmitting, isValid }
  } = useForm({
    resolver: zodResolver(formSchema)
  });

  const hasCardInfoCPF =
    selectedIdentityInputType === IdentityInputTypeEnum.CPF &&
    !productInfo?.strPlasticoTitularNumero;

  const handleOnSubmitForm = handleSubmit(async (formData) => {
    try {
      const cardNumber =
        selectedIdentityInputType === IdentityInputTypeEnum.CPF
          ? productInfo?.strPlasticoTitularNumero
          : formData.card;

      if (cardNumber) {
        const { data } =
          await terminalResource.consultLimitsTerminal(cardNumber);
        if (data) {
          push(ROUTES.consultLimitsReceipt, data);
        } else error("Cartão inválido, tente novamente.");
      }
    } catch (err: unknown) {
      if (err instanceof AxiosError && err.response?.data?.strMensagem) {
        error(err.response.data.strMensagem);
        return;
      }
      error("Cartão inválido, tente novamente.");
    }
  });

  const isButtonDisabled =
    (selectedIdentityInputType === IdentityInputTypeEnum.CPF &&
      !hasCardInfoCPF &&
      !isValid) ||
    !isValid;

  return {
    back,
    isMobile,
    control,
    handleOnChangeIdentityType,
    selectedIdentityInputType,
    handleOnSelectProduct,
    handleOnSubmitForm,
    isValid,
    isSubmitting,
    isButtonDisabled
  };
};
